import { useEffect } from 'react'
import mainStore from '../../store'

/**
 * モジュール固有の Redux store をグローバル main store に同期する。 main store が変化するたびに `UPDATE_FROM_MAIN` を dispatch し、unmount 時に購読解除する。
 *
 * @param {import('redux').Store} moduleStore モジュール側の store
 */
export const useMainStoreSync = (moduleStore) => {
  useEffect(() => {
    const unsubscribe = mainStore.subscribe(() => {
      moduleStore.dispatch({
        type: 'UPDATE_FROM_MAIN',
        payload: mainStore.getState()
      })
    })
    return unsubscribe
  }, [moduleStore])
}
